const TeamData = {
    TeamMembers: [
        {
            id:1,
            name:"Monowar Hossain",
            position:"Head of Idea",
            imgUrl:"1",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:2,
            name:"Mahabubul Alam Reyad",
            position:"CEO and Founder",
            imgUrl:"2",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:3,
            name:"Apurba Mondal",
            position:"UI/UX Designer",
            imgUrl:"3",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:4,
            name:"Tarikul Islam Rumi",
            position:"Full Statck Dev",
            imgUrl:"4",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ]
        },

    ],

}


export default TeamData
